import { useState } from "react";
import type { TwentySettings } from "../../types/timer-settings";
import { DurationSlider, ToggleSwitch, SoundConfigRow } from "./TimerSettingsAtoms";

interface TwentySettingsSectionProps {
  readonly settings: TwentySettings;
  readonly onUpdate: (patch: Partial<TwentySettings>) => void;
}

export function TwentySettingsSection({ settings, onUpdate }: TwentySettingsSectionProps) {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="border border-border rounded-lg overflow-hidden">
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="w-full flex items-center justify-between px-4 py-2.5 bg-surface-alt hover:bg-surface-alt/80 text-sm font-semibold text-ink"
      >
        <span>20-20-20</span>
        <span className="text-ink-muted text-xs">{expanded ? "▲" : "▼"}</span>
      </button>

      {expanded && (
        <div className="px-4 py-3 flex flex-col gap-4">
          <DurationSlider
            label="Temps d'ecran"
            value={settings.screenDuration}
            min={1}
            max={60}
            unit="min"
            onChange={(v) => onUpdate({ screenDuration: v })}
          />
          <DurationSlider
            label="Pause regard"
            value={settings.breakDuration}
            min={5}
            max={120}
            unit="sec"
            onChange={(v) => onUpdate({ breakDuration: v })}
          />
          <ToggleSwitch
            label="Demarrage automatique"
            checked={settings.autoStart}
            onChange={(v) => onUpdate({ autoStart: v })}
          />
          <ToggleSwitch
            label="Demarrer au skip"
            checked={settings.autoStartOnSkip}
            onChange={(v) => onUpdate({ autoStartOnSkip: v })}
          />
          <SoundConfigRow
            label="Son de transition"
            config={settings.transitionSound}
            onChange={(v) => onUpdate({ transitionSound: v })}
          />
        </div>
      )}
    </div>
  );
}
